import { useDefineSingletonFn } from "@/utils/defineSingletonFn";
import { ref } from "vue";
import { useRouter } from "vue-router";

export const handlePrevRoute = () => {
  const prevRouteName = ref<string>();
  return { prevRouteName };
};

export const useHandlePrevRoute = useDefineSingletonFn(handlePrevRoute);

export const handlePrevRouteObserver = () => {
  const router = useRouter();

  const { prevRouteName } = useHandlePrevRoute();

  router.afterEach((to, from) => {
    prevRouteName.value = from.name?.toString() ?? "";
  });
};
